<template>
  <ErrorComponent :errorNb="errorNb" :homeName="homeName" />
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent.vue";

export default {
  name: "NotFoundPages",
  components: { ErrorComponent },
  props: {
    homeName: {
      type: String,
      default: "welcome",
    },
  },
  data() {
    return {
      errorNb: "404",
    };
  },
};
</script>
